/* eslint-disable no-inner-declarations */
/* eslint-disable no-param-reassign */
import { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import usePauseBrowserScroll from "common/hooks/usePauseBrowserScroll";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import ButtonNew from "components/atoms/ButtonNew/index";
import GoToTop from "components/atoms/GoToTop";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";
import Breadcrumb from "components/molecules/Breadcrumb";
import FormNewsLetter from "components/molecules/FormNewsletter";
import SocialShare from "components/molecules/SocialShare/SocialShare";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";

import RenderTocOrRelated from "./RenderTocOrRelated/index";
import AuthorAndTime from "./AuthorAndTime";
import Indicator from "./Indicator";
import MainContent from "./MainContent";

import styles from "./MainContent/Index.module.scss";

const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const EbookModal = dynamic(() => import("components/molecules/EbookModal"), {
  ssr: false,
});

const FormDownloadModal = dynamic(() => import("./FormDownloadModal"), {
  ssr: false,
});

const PostModal = dynamic(() => import("./PostModal"), {
  ssr: false,
});

const Whitepaper = dynamic(() => import("./WhitepaperModal"), {
  ssr: false,
});

const getReadingTime = (str) => {
  const words = str.replace(/<[^>]+>/g, "").split(" ").length;
  const readTime = Math.floor(words / 250);

  if (readTime <= 1) {
    return "1 minute";
  }

  return `${readTime} minutes`;
};

const checkDataFormId = (id) => {
  if (id === "ebook-shortcode-offshore") {
    return { form_id: 21, country: "Offshore Company" };
  }
  if (id === "ebook-shortcode-delaware") {
    return { form_id: 24, country: "Delaware" };
  }
  if (id === "ebook-shortcode") {
    return { form_id: 20, country: "Hong Kong" };
  }
  if (id === "ebook-shortcode-singapore") {
    return { form_id: 26, country: "Singapore" };
  }

  return {
    form_id: "",
    country: "",
  };
};
const dataID = "";

const PostTemplate = ({
  data,
  dataJson,
  specialLayout,
  haveEbook,
  hiddenFeatureImg,
}) => {
  const { post, recentPosts, relatedPosts } = data;
  const getIframe = post.content.match(/<iframe .*?<\/iframe>/g) || "";
  const [contentAfterSplit] = useState(
    (getIframe?.length > 0 && post.content?.split(getIframe[0])) || post
  );
  const readingTime = getReadingTime(post?.content);
  const [modalShow, setModalShow] = useState(false);
  const [ebookShow, setEbookShow] = useState(false);
  const [showFormDownload, setShowFormDownload] = useState(false);
  const [haveFormDownload, setHaveFormDownload] = useState(false);
  const [typeFormDownload, setTypeFormDownload] = useState("checklist_hk");
  const [haveWhitepaper, setHaveWhitepaper] = useState(false);
  const [whitepaperShow, setWhitepaperShow] = useState(false);
  const [tableSlideCount] = useState(0);
  const category =
    post.categories.nodes.find((item) => item.parent === null) || "";
  const country =
    (category?.name.toLowerCase() === "articles" &&
      post.categories.nodes.find((item) => item.parent !== null)) ||
    "";
  const [screen, setScreen] = useState();

  useResizeScreenModified(setScreen);
  usePauseBrowserScroll();

  useEffect(() => {
    if (document.getElementsByClassName("shortcode_download_form").length > 0) {
      setHaveFormDownload(true);
      document
        .querySelectorAll(".shortcode_download_form.btn")
        .forEach((item) => {
          item.addEventListener("click", (e) => {
            setTypeFormDownload(e.target.dataset.typeShortcode);
            setShowFormDownload(true);
          });
        });
    }

    if (document.querySelectorAll("#whitepaper-shortcode .btn").length > 0) {
      setHaveWhitepaper(true);
      document
        .querySelectorAll("#whitepaper-shortcode .btn")
        .forEach((item) => {
          item.addEventListener("click", () => {
            setWhitepaperShow(true);
          });
        });
    }
  }, [modalShow]);

  useEffect(() => {
    document
      .querySelectorAll('#ez-toc-container a[href^="#"]')
      .forEach((anchor) => {
        // eslint-disable-next-line func-names, space-before-function-paren
        anchor.addEventListener("click", function (event) {
          event.preventDefault();
          // eslint-disable-next-line no-invalid-this
          const hash = this.getAttribute("href")
            .split("#")
            .filter((item) => item)
            .join("");
          const el = document.getElementById(hash);

          window.scrollTo({
            left: 0,
            top: el.getBoundingClientRect().top + window.pageYOffset - 90,
            behavior: "smooth",
          });
          if (window.history.pushState) {
            window.history.pushState(null, null, `#${hash}`);
          }
        });
      });

    // Radio handle click
    const radiosList = document.getElementsByName("checkLink");
    const checkList = document.getElementsByClassName("check-option");
    const btnGetStarted = document.getElementById("btn-get-started");

    if (radiosList && radiosList.length > 0) {
      radiosList.forEach((radio, radioIdx) => {
        if (radioIdx === 0) {
          radio.checked = true;
        }
        function checkRadio() {
          radio.checked = true;
          btnGetStarted.href = radio.value;
        }
        radio.addEventListener("change", checkRadio);
        checkList[radioIdx].addEventListener("click", checkRadio);
      });
    }

    // Table handle
    const tableList = document.getElementsByTagName("table");

    if (tableList) {
      const tableWithRowSpan = [...tableList].filter(
        (item) =>
          [...item.rows].filter(
            (element) =>
              [...element.cells].filter((i) => i.rowSpan > 1).length > 0 &&
              element.parentElement.nodeName === "TBODY"
          ).length > 0
      );
      const tableNotHead = [...tableList].filter(
        (item) => item.firstElementChild.nodeName === "TBODY"
      );

      if (tableWithRowSpan.length > 0) {
        tableWithRowSpan.map((item) => item.classList.add("table-rowspan"));
      }
      if (tableNotHead.length > 0) {
        tableNotHead.map((item) => item.classList.add("table-notheader"));
      }
    }
  }, []);
  useEffect(() => {
    const tableWithButtonNext =
      document.getElementsByClassName("table-with-arrow");

    [...tableWithButtonNext].map((item, index) => (item.id = `test-${index}`));
    for (let i = 0; i < tableWithButtonNext.length; i++) {
      const table = document.getElementById(`test-${i}`);

      function nextColumn(value) {
        [...table.rows].map((item) =>
          [...item.cells].map((e, index) =>
            index === value - 1 ? (e.style.display = "none") : null
          )
        );

        [...table.rows].map((item) =>
          [...item.cells].map((e, index) =>
            index === value ? (e.style.display = "table-cell") : null
          )
        );
      }

      function prevColumn(value) {
        [...table.rows].map((item) =>
          [...item.cells].map((e, index) =>
            index === value + 1 ? (e.style.display = "none") : null
          )
        );
        [...table.rows].map((item) =>
          [...item.cells].map((e, index) =>
            index === value ? (e.style.display = "table-cell") : null
          )
        );
      }
      [...table.rows[0].cells].forEach((item, index) => {
        // Button Next
        const buttonNext = document.createElement("button");

        buttonNext.className = "button-next-arrow block lg:hidden";
        buttonNext.innerHTML =
          '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" color="#fff" style="color:#fff" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>';
        buttonNext.addEventListener("click", () => nextColumn(index + 1));
        // Button Prev
        const buttonPrev = document.createElement("button");

        buttonPrev.className = "button-prev-arrow block lg:hidden";
        buttonPrev.innerHTML =
          '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" color="#fff" style="color:#fff" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>';
        buttonPrev.addEventListener("click", () => prevColumn(index - 1));
        if (index > 0) {
          if (index == 1) {
            item.appendChild(buttonNext);
          } else if (index == table.rows[0].cells.length - 1) {
            item.appendChild(buttonPrev);
          } else {
            item.appendChild(buttonNext);
            item.appendChild(buttonPrev);
          }
          item.id = `test-${i}-${index}`;
        }
      });
    }
  }, [tableSlideCount]);

  const renderToc = () => {
    return (
      <RenderTocOrRelated
        post={post}
        dataJson={dataJson}
        haveEbook={haveEbook}
        relatedPosts={
          post?.parts?.parts?.length > 0 ? post?.parts?.parts : relatedPosts
        }
      >
        {dataJson &&
          screen === "DESKTOP" &&
          dataJson.guide_link &&
          dataJson.guide_link.forEach((item, index) => {
            if (item.chosenPost === post.databaseId) {
              return (
                <div
                  key={index}
                  className="group mt-[30px] rounded-xl  bg-bbc-gradient-liner3 px-3 py-10"
                >
                  <Img {...item.img} alt="place-holder" />
                  <p className="text-center text-2xl font-semibold text-bbc-white">
                    {item.title}
                  </p>
                  <p className="mt-4 text-center text-bbc-white">
                    {item.description}
                  </p>
                  {item.link ? (
                    <div className="mt-6 flex w-full justify-center">
                      <ButtonNew
                        as="a"
                        href={item.link}
                        className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize text-bbc-white hover:bg-bbc-white hover:text-bbc-primary"
                        target="_blank"
                      >
                        Try now
                      </ButtonNew>
                    </div>
                  ) : (
                    <div className="mt-6 flex w-full justify-center">
                      <ButtonNew
                        onClick={() => setShowFormDownload(true)}
                        className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize text-bbc-white hover:bg-bbc-white hover:text-bbc-primary"
                      >
                        Unlock guide
                      </ButtonNew>
                      {showFormDownload && (
                        <FormDownloadModal
                          typeFormDownload={item.dataForm}
                          show={showFormDownload}
                          onHide={() => setShowFormDownload(false)}
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            }
          })}
        {haveEbook && (
          <div className="hidden lg:block">
            <div className="mt-10 text-center">
              <h4 className="mb-3 font-semibold">
                Don&apos;t miss out on this guide
              </h4>
              <div>
                <Img
                  src={"/assets/images/common/offshore-ebook.png"}
                  width={762}
                  height={1000}
                  alt="ebook"
                />
              </div>
              <button
                className={`group relative mt-3 h-10 rounded border-0 bg-bbc-brand-500 px-10 py-2 font-bold text-white
                      before:absolute before:right-0 before:top-0 before:h-0 before:w-0.5 before:bg-bbc-brand-500 before:transition-all before:duration-500 before:ease-in-out before:content-['']
                      after:absolute after:right-0 after:top-0 after:h-0.5 after:w-0 after:bg-bbc-brand-500 after:transition-all after:duration-500 after:ease-in-out after:content-['']
                     
                      hover:bg-white hover:text-bbc-brand-500 hover:before:h-full hover:after:w-full `}
                onClick={() => setEbookShow(true)}
              >
                <span
                  className={`before:absolute before:left-0 before:bottom-0 before:h-0 before:w-0.5 before:bg-bbc-brand-500 before:transition-all before:duration-300 before:ease-in-out before:content-['']
                      after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-0 after:bg-bbc-brand-500 after:transition-all after:duration-300 after:ease-in-out after:content-['']
                     group-hover:before:h-full group-hover:after:w-full`}
                >
                  Download Now
                </span>
              </button>
            </div>
            {ebookShow && (
              <Toast>
                <EbookModal
                  show={ebookShow}
                  onHide={() => setEbookShow(false)}
                  apiLink="api/portal/contact_form/profile_request"
                  haveCheckBox={true}
                  checkedId={21}
                  unCheckId={23}
                  imgLeft="/assets/images/common/offshore-ebook.png"
                  imgWidth={762}
                  imgHeight={1000}
                  triggerName="Ebook - Offshore Company"
                />
              </Toast>
            )}
          </div>
        )}
      </RenderTocOrRelated>
    );
  };

  return (
    <>
      <GoToTop />
      <Indicator />
      <section id="banner">
        {specialLayout ? (
          <Banner
            minHeightBanner={`${
              dataJson &&
              dataJson.special_layout &&
              dataJson.special_layout.some(
                (el) => el.chosenPost == post.databaseId
              )
                ? "banner-min-h-503"
                : "banner-min-h-635"
            } `}
            title={post.title}
            bgColor="bg-bbc-gradient-service"
            breadcrumbs={[
              {
                title: category?.name || "",
                uri: category?.uri || "",
              },
              Object.keys(country).length > 0 && {
                title: country?.name,
                uri: country?.uri,
              },
              {
                title: post.title,
                uri: post.uri,
              },
            ].filter((item) => item)}
            leftClassName="relative lg:mt-0 col-12 lg:col-6"
            rightClassName="col-12 lg:col-6"
            description={
              <>
                <div className="mb-6 text-center text-sm leading-6 lg:mb-10 lg:text-left">
                  <AuthorAndTime
                    timeRead={readingTime}
                    fullHead={data?.page?.head}
                  />
                </div>
              </>
            }
            rightContent={
              dataJson &&
              dataJson.special_layout &&
              dataJson.special_layout.some(
                (el) => el.chosenPost == post.databaseId
              ) ? (
                dataJson.special_layout.forEach((item, index) => {
                  if (item.chosenPost == post.databaseId) {
                    return (
                      <Img
                        key={index}
                        className="m-auto lg:w-full"
                        src={item.imgSrc}
                        width={item.width}
                        height={item.height}
                        alt={item.imgAlt}
                        priority={true}
                        wrapper={{
                          className: "bbc-banner-image-bottom-0",
                        }}
                      />
                    );
                  }
                })
              ) : (
                <Img
                  className="m-auto lg:w-full"
                  src="/assets/images/common/special-blog-banner.png"
                  width={562}
                  height={436}
                  alt="banner"
                  priority={true}
                  wrapper={{
                    className: "bbc-banner-image-bottom-0",
                  }}
                />
              )
            }
          ></Banner>
        ) : (
          <div className="container">
            <div className="pt-28  lg:pt-[198px]">
              <Breadcrumb
                items={[
                  {
                    title: category?.name || "",
                    uri: category?.uri || "",
                  },
                  Object.keys(country).length > 0 && {
                    title: country?.name,
                    uri: country?.uri,
                  },
                  {
                    title: post.title,
                    uri: post.uri,
                  },
                ].filter((item) => item)}
                className="mb-6 lg:mb-8"
              />
              <Title
                as="h1"
                className="banner-title-default-color banner-default-title mb-6 lg:mb-10"
              >
                {post.title}
              </Title>
              <div
                className={
                  " min-h-[64px] border-black text-center text-sm lg:flex lg:border-b lg:pb-10 lg:text-left "
                }
              >
                <AuthorAndTime
                  timeRead={readingTime}
                  fullHead={data?.page?.head}
                />
              </div>
            </div>
          </div>
        )}
      </section>
      <section>
        <div className="container">
          <div className="row">
            <div className="lg:col-8" id="post-content">
              {!hiddenFeatureImg && screen !== "TABLET" && (
                <Img
                  image={post.featuredImage?.node}
                  alt={post.title}
                  className=" w-full "
                  wrapper={{
                    className: "hidden md:block w-full h-auto mb-10",
                    style: { maxHeight: "626px" },
                  }}
                  priority={true}
                />
              )}
              {screen !== "DESKTOP" && <div>{renderToc()}</div>}

              {getIframe.length > 0 ? (
                <div className={styles.postsContent}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contentAfterSplit[0],
                    }}
                  ></div>
                  <LazyLoad classNamePrefix="lazy-load-custom">
                    <div
                      dangerouslySetInnerHTML={{ __html: getIframe[0] }}
                    ></div>
                  </LazyLoad>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contentAfterSplit[1],
                    }}
                  ></div>
                  {dataJson &&
                    screen !== "DESKTOP" &&
                    dataJson.guide_link &&
                    dataJson.guide_link.forEach((item, index) => {
                      if (item.chosenPost === post.title) {
                        return (
                          <div
                            key={index}
                            className="group mt-[30px] overflow-y-scroll  rounded-xl bg-bbc-gradient-liner3 px-3 py-10"
                          >
                            <Img src={item.imgSrc} alt="place-holder" />
                            <p className="text-center text-2xl font-semibold text-bbc-white">
                              {item.title}
                            </p>
                            <p className="mt-4 text-center text-bbc-white">
                              {item.description}
                            </p>
                            {item.link ? (
                              <div className="mt-6 flex w-full justify-center">
                                <ButtonNew
                                  as="a"
                                  href={item.link}
                                  className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white"
                                  target="_blank"
                                >
                                  Try now
                                </ButtonNew>
                              </div>
                            ) : (
                              <div className="mt-6 flex w-full justify-center">
                                <ButtonNew
                                  onClick={() => setShowFormDownload(true)}
                                  className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white"
                                >
                                  Unlock guide
                                </ButtonNew>
                                {showFormDownload && (
                                  <FormDownloadModal
                                    typeFormDownload={item.dataForm}
                                    show={showFormDownload}
                                    onHide={() => setShowFormDownload(false)}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        );
                      }
                    })}
                  {post?.faqs && post?.faqs?.faqs && (
                    <div className="mt-10 mb-6">
                      <Faqs
                        data={post.faqs.faqs}
                        buttonClass="lg:px-5 font-normal lg:font-medium !text-base lg:!text-lg"
                        panelClass="lg:px-5"
                      />
                    </div>
                  )}
                  <div className="mt-10">
                    <p style={{ fontSize: "13px", lineHeight: "20px" }}>
                      <span className="font-semibold">Disclaimer: </span>While
                      BBCIncorp strives to make the information on this website
                      as timely and accurate as possible, the information itself
                      is for reference purposes only. You should not substitute
                      the information provided in this article for competent
                      legal advice. Feel free to contact BBCIncorp’s customer
                      services for advice on your specific cases.
                    </p>
                  </div>
                  <SocialShare
                    iconWidth={30}
                    iconHeight={30}
                    title="Share this article"
                    titleClassName={"block"}
                  />
                </div>
              ) : (
                <>
                  <MainContent
                    data={post}
                    dataJson={dataJson}
                    screen={screen}
                  />
                </>
              )}
            </div>
            <div className="hidden lg:col-4 lg:block">{renderToc()}</div>
          </div>
        </div>
      </section>
      {recentPosts.length > 0 && (
        <section className="mb-10 lg:mb-20">
          <div className="container">
            <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
              Industry News & Insights
            </Title>
            <LazyLoad>
              <NewsSlider
                data={{
                  posts:
                    post?.parts?.parts?.length > 0
                      ? post.parts.parts
                      : recentPosts,
                }}
              />
            </LazyLoad>
          </div>
        </section>
      )}
      <FormNewsLetter />
      <span className="hidden lg:col-8"></span>
      <span className="hidden lg:col-5"></span>
      <span className="hidden lg:col-4"></span>
      <span className="hidden lg:col-6"></span>
      <span className="hidden lg:col-7"></span>
      {dataID.length > 0 && (
        <Toast>
          {modalShow && (
            <PostModal
              show={modalShow}
              ebookdata={checkDataFormId(dataID)}
              onHide={() => setModalShow(false)}
            />
          )}
        </Toast>
      )}
      {haveWhitepaper && (
        <Toast>
          {whitepaperShow && (
            <Whitepaper
              show={whitepaperShow}
              onHide={() => setWhitepaperShow(false)}
            />
          )}
        </Toast>
      )}
      {haveFormDownload && (
        <FormDownloadModal
          typeFormDownload={typeFormDownload}
          show={showFormDownload}
          onHide={() => setShowFormDownload(false)}
        />
      )}
    </>
  );
};

export default PostTemplate;
